module.exports = __webpack_public_path__ + "static/media/trash.a8e94acf.svg";